import ModalForm from "./Form";
import { TASK, DATATABLE_EXPORT } from "../../../../Config/ApiUrl";

export const Schema = {
	components: { ModalForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			tableId: "TASK-table",
			rowData: {},
			formId: "TASK-form",
			tableColumns: [
				{
					title: "Date",
					type: "text",
					key: "assigned_date",
				},
				{
					title: "Task",
					type: "text",
					key: "title",
				},
				{
					title: "Assigned By",
					type: "custom-html",
					key: "owner_id",
					isVisible: true,
					modifier: (value) => {
						return value?.full_name
					}
				},
				{
					title: "Assign To",
					type: "custom-html",
					key: "assignee_id",
					isVisible: true,
					modifier: (value) => {
						return value?.full_name
					}
				},
				{
					title: "Due Date",
					type: "text",
					key: "due_date",
				},
				{
					title: "Due Time",
					type: "custom-html",
					key: "due_time",
					isVisible: true,
					modifier: (value) => {
						return value?.slice(0, -3)
					}
				},
				{
					title: "Status",
					type: "custom-html",
					key: "stage_id",
					modifier: (value) => {
						return value?.name
					}
				},
			],
			ENDPOINT: TASK,
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "TASK",
				url: TASK,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "none",
						component: "app-add-modal",
						modalId: "TASK-form",
						disabled: (rowData) => this.isTaskEditAndDeleteDisabled(rowData, "edit"),
					},
					{
						title: "Cancel Task",
						icon: "trash",
						type: "cancel-task",
						disabled: (rowData) => this.isTaskEditAndDeleteDisabled(rowData, "cancel"),
					},
					{
						title: "Complete Task",
						icon: "check",
						type: "complete-task",
						disabled: (rowData) => this.isCompleteTaskDisabled(rowData),
					},
				],
				filters: [
				],
				showFilter: false,
				showSearch: true,
				showCount: true,
				showClearFilter: false,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 10,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
		/**
		 * Delete confirmed $emit Form confirmation modal
		 */
		onDelete() {
			let url = `${this.ENDPOINT}/${this.rowData.id}`;
			this.deleteLoader = true;
			this.axiosDelete(url)
				.then((response) => {
					this.deleteLoader = false;
					$("#demo-delete").modal("hide");
					this.onCancelDelete();
					this.$toastr.s(response.data.message);
					// this.searchAndSelectFilterOptions();
				})
				.catch(({ err }) => {})
				.finally(() => this.$hub.$emit(`reload-${this.tableId}`));
		},
		onCancelDelete() {
			this.deleteConfirmationModalActive = false;
			this.reSetData();
		},
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},

		isTaskEditAndDeleteDisabled(rowData, buttonAction) {
			if (!rowData.owner_id) {
				return false;
			}
			if (buttonAction === "edit" || buttonAction === "cancel") {
				const isNotOwner = rowData.owner_id.id !== this.user.loggedInUser.id;
				const isCancelStage = rowData.stage_id?.id === 2;
				return isNotOwner || (buttonAction === "cancel" && isCancelStage);
			}
			return false;
		},

		isCompleteTaskDisabled(rowData) {
			if (!rowData.assignee_id) {
				return false;
			}
			const isNotAssignee = rowData.assignee_id.id !== this.user.loggedInUser.id;
			const isCompletedStage = rowData.stage_id?.id === 3;
			return isNotAssignee || isCompletedStage;
		}
	},
};
